import { ArrowDownTrayIcon, CheckIcon } from "@heroicons/react/20/solid";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import {
  Square3Stack3DIcon,
  UserCircleIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/solid";
import React from "react";
import EquityFundTabs from "./EquityFundTabs";

export default function EquityFund() {
  return (
    <div className="text-ternary-dark dark:text-ternary-light  ">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto mt-16 max-w-xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h3 className="text-4xl font-bold tracking-tight">Equity Fund</h3>
            <p className="mt-6 text-base max-w-lg leading-7 ">
              This fund aims to offer superior returns over the medium to longer
              term by maximizing long term capital growth by investing primarily
              in listed companies on the Stock Exchanges of Kenya, Uganda and
              Tanzania. The fund has some exposure to offshore listed companies,
              denominated in Euro, Sterling Pound or US Dollar.{" "}
            </p>
            <p className="mt-6  text-xs italic max-w-lg leading-7 ">
              *The indicative rate of return shall not be guaranteed and past
              performance does not guarantee future investment performance. The
              Indicative Rate is not fixed and may, as such, vary from time to
              time depending on the investment period and prevailing economic,
              political or social circumstances. T&C's apply.{" "}
            </p>

            <div className="mt-10 flex items-center gap-x-4">
              <a
                href="#"
                className="mt-10 block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Application Form
              </a>
            </div>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-xl pt-24 lg:flex-shrink-0">
            <EquityFundTabs />
          </div>
        </div>
      </div>
    </div>
  );
}
